<template>
    <section class="plugin-home-registration">
        <div class="plugin-home-registration__container">
            <div class="plugin-home-registration__content">
                <div class="plugin-home-registration__content-text"
                     v-html="title"
                />
                <plugin-phone-input
                    v-model="phone"
                    v-bind:required="true"
                />
                <div class="plugin-home-registration__content-button">
                    <ui-button
                        v-bind:href="loginUrl"
                        theme="primary"
                        size="huge"
                        v-bind:is-uppercase="false"
                        v-on:click="submit"
                        is-width-free
                    >
                        Начать инвестировать
                    </ui-button>
                </div>
                <div class="plugin-home-registration__content-button-mobile">
                    <ui-button
                        v-bind:href="loginUrl"
                        theme="primary"
                        size="lg"
                        v-bind:is-uppercase="false"
                        v-on:click="submit"
                    >
                        Начать инвестировать
                    </ui-button>
                </div>
                <div class="plugin-home-registration__content-image-mobile"
                     v-bind:style="backgroundStyle"
                />
            </div>
            <div class="plugin-home-registration__image"
                 v-bind:style="backgroundStyle"
            >
            </div>
        </div>
    </section>
</template>

<script>
import utils from '~/utils';
import config from '~/config';

export default {
    name: 'plugin-home-registration',
    props: {
        image: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            phone: null,
            error: '',
            loginUrl: config.urls.auth.login,
        };
    },
    computed: {
        backgroundStyle() {
            if (!this.image) {
                return null;
            }
            const resize = utils.common.getResize({
                1920: 43,
                1023: 100,
            });
            // return { backgroundImage: `url(${utils.common.injectResize(this.image, resize)})` };
            return { backgroundImage: `url(${this.image})` };
        },
    },
    methods: {
        submit() {
            const url = new URL(`${window.location.origin}${config.urls.auth.login}`);

            if (this.phone) {
                const digits = this.phone.replace(/\D/g, '');

                if (digits.length !== 11) {
                    this.error = 'Введите корректный номер телефона';
                    return false;
                }

                this.error = '';

                url.searchParams.append('phone', this.phone);

                // Проверка на российские операторы (опционально)
                /* const firstDigits = digits.slice(1, 4); // после +7
                if (!['900', '901', '902', '903', '904', '905', '906', '908', '909', '910',
                    '911', '912', '913', '914', '915', '916', '917', '918', '919', '920',
                    '921', '922', '923', '924', '925', '926', '927', '928', '929', '930',
                    '931', '932', '933', '934', '935', '936', '937', '938', '939', '950',
                    '951', '952', '953', '954', '955', '956', '957', '958', '959', '960',
                    '961', '962', '963', '964', '965', '966', '967', '968', '969', '970',
                    '971', '977', '978', '980', '981', '982', '983', '984', '985', '986',
                    '987', '988', '989'].includes(firstDigits)) {
                    this.error = 'Укажите корректный номер российского оператора';
                } else {
                    this.error = '';
                } */
            }

            window.location.href = url.href;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-registration {
    .container-landing();

    display: flex;
    align-items: center;
    min-height: 780px;

    &__container {
        margin: 0 auto;
        position: relative;
        max-width: @landing-max-width;
    }
    &__content {
        position: relative;

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 48px;

        width: 86%;
        min-height: 600px;
        padding: 64px;
        padding-right: 220px;

        border-radius: @border-radius-xxxl;

        background-color: @color-gray-darker;

        overflow: hidden;

        &-text {
            font-size: 62px;
            line-height: 68px;
            font-weight: bold;

            white-space: pre-line;

            color: white;
        }
        &-button-mobile {
            display: none;
        }
        &-image-mobile {
            display: none;
        }
    }
    &__image {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;

        width: 400px;
        height: 800px;
        max-width: 100%;

        background-size: contain;
        background-position: left;
        background-repeat: no-repeat;
    }

    @media @media-md-down {
        min-height: auto;
        &__content {
            .container();

            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 32px;
            padding-bottom: 0;
            border-radius: @border-radius-xxl;
            text-align: center;

            &-text {
                font-size: 36px;
                line-height: 42px;
                font-weight: bold;
            }
            &-button {
                display: none;
            }
            &-button-mobile {
                width: 100%;
                display: block;
            }
            &-image-mobile {
                display: block;
                width: 100%;
                height: 250px;

                background-size: 250px;
                background-position: top;
                background-repeat: no-repeat;
            }
        }
        &__image {
            display: none;
        }
    }

    @media @media-sm-down {
        min-height: auto;
        &__content {
            gap: 6px;
            padding: 24px 24px 0 24px;
        }
    }
}
</style>
